import React, { FC } from 'react'

import { InHouseMonitoringStatus as InHouseMonitoringStatusEnum } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter, CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface InHouseMonitoringStatusProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const InHouseMonitoringStatus: FC<InHouseMonitoringStatusProps> = props => {
  const inHouseMonitoringStatusOptions = Object.keys(InHouseMonitoringStatusEnum).map(status => {
    const value = InHouseMonitoringStatusEnum[status as keyof typeof InHouseMonitoringStatusEnum]
    return {
      value,
      label: capitalizeEachFirstLetter(value),
    }
  })

  return (
    <CheckboxBasedFilter
      title="In-House Monitoring"
      options={inHouseMonitoringStatusOptions}
      {...props}
    />
  )
}
